<template>
  <div>
    <v-card :width="$isMobile ? (windowInnerWidth * 0.98) - 80 : 734" style='border: none; background: #f3f4f6'>
      <v-card-text class='position-relative pl-0 pb-0' style='padding-right: 0'>
        <div class='mb-2 font-weight-bold ml-4'>
          {{ title }}
        </div>
        <div v-if='dataList.length > 0' class='mt-4 d-flex align-center flex-wrap'>
          <v-card
            v-for='(item, index) in dataList'
            class="mb-4 cursor-pointer ml-4"
            :key='index'
            :style="{width: $isMobile ? 'calc(100% - 32px)' : '47%'}"
            @click.native='radioChange(item)'
          >
            <v-card-title class='pl-2 pr-2 d-flex align-center justify-space-between'>
              <div class='d-flex align-center d-inline-block text-truncate' style='width: 85%'>
                <img style='width: 30px; height: 30px'
                     :src="require('@/assets/images/Icon-位置.png')"
                     alt='' />
                <div>
                  <v-tooltip left>
                    <template v-slot:activator='{ on, attrs }'>
                      <span v-bind='attrs' v-on='on' style='font-size: 16px; color: #000'>
                        {{ item.buildindValue }}
                      </span>
                    </template>
                    <span>{{ item.buildindValue }}</span>
                  </v-tooltip>
                </div>
              </div>
              <div>
                <radio-circle
                  :value='item.radioValue'
                  :disabled='messageData.buildingDisabled'
                  @click.native.stop='radioChange(item)'
                >
                </radio-circle>
              </div>
            </v-card-title>
          </v-card>
        </div>
        <div v-if='dataList.length === 0' class='text-center mt-3 mb-2'>
          {{ language === 'chinese' ? '暂无数据' : 'No data available.' }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          :disabled='messageData.buildingDisabled'
          depressed
          small
          @click="$emit('cancelChat', {language}); messageData.buildingDisabled = true"
        >
          {{ language === 'chinese' ? '取消' : 'Cancel' }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <message-box
      :msg-id='msgId'
      class='mt-2'
      @copy='copy'
      :message='messageData'
      :like-type='messageData.likeType'
      :isCustomCopyWriteText='true'
      @refreshAnswer="$emit('refreshAnswer', messageData)"
    ></message-box>
  </div>
</template>

<script>
import MessageBox from '../components/MessageBox.vue'
import { PageHandle } from '@/modules/chat/util/ChatBotUtil'
import RadioCircle from '../components/RadioCircle.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'bookSeatCardList',
  components: { MessageBox, RadioCircle },
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    msgId: {
      type: Number,
      default: 0,
    },
    messageData: {
      type: Object,
      default: {},
    },
    immediatelyRender: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  watch: {
    list: {
      handler(val) {
        this.pageHandleMethod(val)
      },
      immediate: true,
    },
    language: {
      handler(val) {
        this.title = val === 'chinese' ? '请选择楼号' : 'Please select your building'
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
    }),
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {
      headers: [
        {
          text: '城市',
          align: 'start',
          sortable: false,
          value: 'cityValue',
        },
        { text: '楼号', value: 'buildindValue', sortable: false },
        { text: '操作', value: 'optional', sortable: false },
      ],
      messages: '',
      showTable: false,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      title: '请选择楼号：',
      pageOption: {
        page: 1,
        total: 0,
        size: 12,
        length: 0,
      },
      dataList: [],
      pageHandle: null,
    }
  },
  async mounted() {
    if (this.messageData.tipMsg) {
      this.title = this.messageData.tipMsg
    }
    if (!this.immediatelyRender) {
      await this.displayMessageCharacterByCharacter(this.title)
    } else {
      this.showTable = true
    }
  },
  methods: {
    pageHandleMethod(valList = this.list) {
      this.pageHandle = new PageHandle(valList, this.pageOption.page, this.pageOption.size)
      this.pageOption.length = this.pageHandle.getPages()
      this.dataList = this.pageHandle.getCurrentPageList()
      this.dataList.forEach(item => {
        item.radioValue = false
      })
      this.componentInitSet()
    },
    componentInitSet() {
      if (this.messageData.componentSelectionValue) {
        const componentSelectionValue = JSON.parse(this.messageData.componentSelectionValue)
        if (componentSelectionValue) {
          this.dataList.forEach(el => {
            this.$set(el, 'radioValue', componentSelectionValue.buildindValue === el.buildindValue)
          })
        }
      }
    },
    radioChange(item) {
      if (this.messageData.buildingDisabled) {
        return
      }
      this.dataList.forEach(el => {
        this.$set(el, 'radioValue', item.buildingId === el.buildingId)
      })
      this.$set(this.messageData, 'buildingDisabled', this.modelType === 'DeepSeek')
      this.$forceUpdate()
      this.$emit('selectBuildingChange', { ...item, answerId: this.msgId })
    },
    pageChange() {
      this.pageHandleMethod()
    },
    async copy() {
      let copyTemplate = '城市\t\t\t' + '楼号\t\n'
      const startIndex = (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage
      const endIndex = startIndex + this.tableOptions.itemsPerPage
      this.list.slice(startIndex, endIndex).forEach(item => {
        copyTemplate = copyTemplate + item.cityValue + '\t' + item.buildindValue + '\t\n'
      })
      await navigator.clipboard.writeText(copyTemplate)
      this.$message.success('复制成功')
    },
    displayMessageCharacterByCharacter(text) {
      var char = text.split('')
      for (let i = 0; i < char.length; i++) {
        setTimeout(() => {
          this.messages += char[i]
          this.$forceUpdate() // 强制视图更新以显示最新文本
          // this.scrollToBottom() // 确保新消息可见
        }, i * 150) // 1秒间隔
      }
      setTimeout(() => {
        this.showTable = true
        this.$emit('renderTableComplete')
      }, 2100)
      // this.showTable = true
    },
    // 预定按钮点击事件
    reserve(item) {
      // 拼接参数到 URL
      const url = `https://support-places.accenture.com/places?id=places_reservation_form&building=${encodeURIComponent(item.buildingId)}&start=${encodeURIComponent(item.startTime)}&end=${encodeURIComponent(item.endTime)}&floor=${encodeURIComponent(item.floorId)}&goback=goback&reservable_ids=${encodeURIComponent(item.roomId)}&timezone=Asia%2FShanghai&primary_building=${encodeURIComponent(item.buildingId)}&neighborhood=&reservation_path=browse_all&ignore_same_day_validation=false&all_day=false&reservable_module=${(item.reservableModule)}`
      window.location.href = url // 跳转到带参数的 URL
    },
  },
}
</script>

<style scoped>

</style>
